var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart-coupons" }, [
    _c("div", { staticClass: "checkout__header" }, [
      _c("div", { staticClass: "cart__search" }, [
        _c(
          "label",
          {
            staticClass: "cart__search__label",
            attrs: { for: "coupon-input" }
          },
          [
            _c("h3", { staticClass: "checkout__header__heading" }, [
              _vm._v(_vm._s(_vm.$modeoL10n.discount_code))
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "cart__search__input-container" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.coupon,
                expression: "coupon"
              }
            ],
            staticClass:
              "cart__search__input cart__search__input--with-submit cart__search__input--small-in-mobile small",
            attrs: {
              id: "coupon-input",
              type: "text",
              autocomplete: "new-password",
              placeholder: _vm.$modeoL10n.enter_coupon_code
            },
            domProps: { value: _vm.coupon },
            on: {
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                },
                function($event) {
                  return _vm.handleKeyDown()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.coupon = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "cart__search__submit btn btn--small",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.applyCoupon($event)
                }
              }
            },
            [_vm._v("\n          " + _vm._s(_vm.$modeoL10n.add) + "\n        ")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.appliedCoupons && _vm.appliedCoupons.length
      ? _c(
          "div",
          { staticClass: "checkout__subsection" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$modeoL10n.applied) +
                " " +
                _vm._s(
                  _vm.appliedCoupons.length > 1
                    ? _vm.$modeoL10n.discount_code_plural
                    : _vm.$modeoL10n.discount_code_singular
                ) +
                "\n    "
            ),
            _vm._l(_vm.appliedCoupons, function(appliedCoupon, index) {
              return _c(
                "div",
                { key: index, staticClass: "checkout__coupon" },
                [
                  _c("strong", [_vm._v(_vm._s(appliedCoupon.code))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "checkout__coupon--remove btn",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.removeCoupon(appliedCoupon.code)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "screen-reader-text" }, [
                        _vm._v(_vm._s(_vm.$modeoL10n.remove))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  appliedCoupon.description
                    ? [
                        _c(
                          "span",
                          { staticClass: "checkout__coupon--description" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(appliedCoupon.description) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", {
          staticClass: "error-notification",
          domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.errorMessage)) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d0c8567", { render: render, staticRenderFns: staticRenderFns })
  }
}